import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";
import {FormControlLabel, InputAdornment} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";

export default function ManageInventoryTypeModal(props) {

  const [context, setContext] = useContext(AppContext);
  const [inventoryType, setInventoryType] = useState(props.inventoryType || {});
  const [formInvalid, setFormInvalid] = useState(false);

  const [cafeMode, setCafeMode] = useState(props?.cafeMode || false);

  useEffect(() => {
    setInventoryType(props?.inventoryType);
  }, [props?.inventoryType]);

  const [isNew, setIsNew] = useState(!!!props.inventoryType?.guid);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(inventoryType)
  });

  const handleClose = () => {
    props.handleClose();
  };

  const handleSave = (data) => {
    props.handleSave(data);
  };


  const [partyItem, setPartyItem] = useState(props?.inventoryType?.partyItem || false);
  const [cafeItem, setCafeItem] = useState(props?.inventoryType?.cafeItem || false);

  const handlePartyItemCheck = (e) =>{
    setPartyItem(e.target.checked);
    if (e.target.checked) {
      setValue('cafeItem', false)
      setCafeItem(false);
    }
  }

  const handleCafeItemCheck = (e) =>{
    setCafeItem(e.target.checked);
    if (e.target.checked) {
      setValue('partyItem', false);
      setPartyItem(false);
    }
  }

  return (
    <Modal onHide={handleClose} size={'lg'} show={props.show}>
      <form onSubmit={handleSubmit(handleSave)} id={'inventoryTypeForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{isNew ? 'Create New' : 'Manage'} Inventory Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <MDInput
                        type="text"
                        {...register('name')}
                        autoComplete="off" required
                        className="form-control" id="name"
                        InputLabelProps={{shrink: true}}
                        placeholder={"Enter Inventory Type Name"}
                        label="Inventory Type Name"/>

                    </div>
                  </Col>
                </Row>

                <Row className={'mt-2'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group mt-3">

                      <MDInput
                        type="text"
                        {...register('desc')}
                        autoComplete="off"
                        className="form-control" id="desc"
                        InputLabelProps={{shrink: true}}
                        placeholder={"Enter Inventory Type Description"}
                        label="Inventory Type Description"/>

                    </div>
                  </Col>
                </Row>

                <Row className={'mt-2'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group mt-3">
                      <MDInput type="text" step="0.01" required
                               {...register('salesTax', {
                                 valueAsDouble: true
                               })}
                               onChange={(e) => {
                                 e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                               }}
                               InputProps={{
                                 endAdornment: <InputAdornment position="end">
                                   <span className={'fa fa-percentage'}></span>
                                 </InputAdornment>,
                               }}
                               InputLabelProps={{shrink: true}}
                               defaultValue={'0.00'}
                               autoComplete="off"
                               placeholder={"Enter Sales Tax Percentage"}
                               className="form-control" id="salesTax"
                               label="Sales Tax"/>

                    </div>
                  </Col>
                </Row>

                <Row className={'mt-4'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <FormControlLabel sx={{
                        display: 'inline-block'
                      }}
                                        control={
                                          <Checkbox
                                            defaultChecked={props?.inventoryType?.tippableItem}
                                            {...register('tippableItem')}
                                            name="tippableItem"/>
                                        }
                                        label="Tips enabled"
                      />
                      <p className={'py-2 fw-light'}>
                        Turn on tipping for this inventory type.
                      </p>

                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <FormControlLabel sx={{
                        display: 'inline-block'
                      }}
                                        control={
                                          <Checkbox
                                            {...register('partyItem', {
                                              onChange: (e)=> {
                                                handlePartyItemCheck(e)
                                              }
                                            })}
                                            checked={partyItem}
                                            name="partyItem"/>
                                        }
                                        label="Add On Item"
                      />
                      <p className={'py-2 fw-light'}>
                        Use Add On Item to indicate this is an add on to an existing service.
                      </p>

                    </div>
                  </Col>
                </Row>

                {cafeMode && <>
                  <Row>
                    <Col className={'col'} sm={12} xs={12}>
                      <div className="form-group">
                        <FormControlLabel sx={{
                          display: 'inline-block'
                        }}
                                          control={
                                            <Checkbox
                                              {...register('cafeItem', {
                                                onChange: (e)=> {
                                                  handleCafeItemCheck(e)
                                                }
                                              })}
                                              checked={cafeItem}
                                              name="cafeItem"/>
                                          }
                                          label="Cafe Item"
                        />
                        <p className={'py-2 fw-light'}>
                          Use cafe items to designate food &amp; beverages from store items.
                        </p>

                      </div>
                    </Col>
                  </Row>
                </>}

              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={formInvalid || props.saving}>
            {props.saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}